document.addEventListener('DOMContentLoaded', () => {
  const heroVisuals = document.querySelectorAll('.db-hero__visual[data-db-tilt="true"]');

  if (!heroVisuals.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  heroVisuals.forEach((visual) => {
    if (window.innerWidth < 990) return;

    const wrap = visual.querySelector('.db-hero__visual-wrap');
    if (!wrap) return;

    let rafId = null;

    const resetTilt = () => {
      wrap.style.transform = 'rotateX(0deg) rotateY(0deg)';
    };

    const handleMove = (event) => {
      const rect = visual.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      const px = (x / rect.width) - 0.5;
      const py = (y / rect.height) - 0.5;

      const rotateY = px * 8;
      const rotateX = py * -8;

      if (rafId) cancelAnimationFrame(rafId);

      rafId = requestAnimationFrame(() => {
        wrap.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      });
    };

    visual.addEventListener('mousemove', handleMove);
    visual.addEventListener('mouseleave', resetTilt);

    window.addEventListener('resize', () => {
      if (window.innerWidth < 990) {
        resetTilt();
      }
    });
  });
});